module.exports = __webpack_public_path__ + "img/desktop.5b4ad5cc.svg";